module.exports = __webpack_public_path__ + "img/scratch.1603e0e2.svg";